module.exports = __webpack_public_path__ + "img/map_decentral.f2ee9407.jpg";